export type IncidentRuleUsed = {
  ruleId: string;
  version: number;
  source: 'GLOBAL' | 'TENANT';
  title: string | null;
};

/**
 * Label of a rule given to the diagnosis (ADR-0039). The API hides the title of
 * a global rule from tenant users: it is shown as "EVIMO rule".
 */
export function ruleUsedLabel(
  rule: IncidentRuleUsed,
  evimoRuleLabel: string,
): string {
  return rule.title?.trim() ? rule.title : evimoRuleLabel;
}
